import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

/**
 * 未登录时重定向到登录页。
 *
 * 从 `router.tsx` 抽出来是因为 **Phase 5 有第二棵树要用它**：`/cashier/*` 挂在
 * `AppLayout` 之外（收银端是独立外壳），也要过同一道登录门。留在 `router.tsx` 里
 * 再抄一份会漂移；从 `router.tsx` 反向 import 到 `cashier/routes.tsx` 会成环。
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
